<!--订单查询-->
<template>
  <div>
    <app-breadcrumb />
    <div class="page-container order-query">
      <p style="font-weight: 600 ;color: green">{{this.$t('fi.type.ac.e') +'：'}}<span style="color:red;">{{this.canUseF$}}</span></p>
      <el-form size="small" :inline="true" :model="listQuery">
        <!--     单据编号   -->
        <el-form-item size="mini" :label="$t('poOrderAgent.provideno')">
          <el-input v-model.trim="listQuery.orderNo" clearable :placeholder="$t('')" />
        </el-form-item>
        <!--        经销商编号-->
        <el-form-item size="mini" :label="$t('miMember.memberNo')">
          <el-input v-model.trim="listQuery.memberNo" clearable :placeholder="$t('')" />
        </el-form-item>
        <!--        经销商姓名-->
        <el-form-item size="mini" :label="$t('miMember.name')">
          <el-input v-model.trim="listQuery.name" clearable :placeholder="$t('')" />
        </el-form-item>
        <!--        单据类型-->
        <el-form-item size="mini" :label="$t('fiAcInput.orderType')">
          <el-select v-model="listQuery.orderType" clearable :placeholder="$t('')">
            <el-option value="" />
            <el-option v-for="role in orderTyleList" :key="role.code" :label="$lt(initDict.orderTyoe,role.title)" :value="role.code" />
          </el-select>
        </el-form-item>
        <!--        结算-->
        <el-form-item size="mini" :label="$t('button.settle')">
          <el-select v-model="listQuery.locked" clearable :placeholder="$t('')">
            <el-option value="" />
            <el-option v-for="role in bdPeriodStatusList" :key="role.code" :label="$lt(initDict.bdPeriodStatus,role.title)" :value="role.code" />
          </el-select>
        </el-form-item>
        <!--       期次-->
        <el-form-item size="mini" :label="$t('PoOrder.periodWeek')">
          <el-select v-model="listQuery.periodWeek" clearable :placeholder="$t('')">
            <el-option value="" />
            <el-option v-for="role in wWeekList" :key="role.id" :label="role.wWeek" :value="role.wWeek" />
          </el-select>
        </el-form-item>
        <!--          搜索-->
        <el-button size="mini"  type="primary" :loading="btnloading" icon="el-icon-search" @click="handleFilter">{{ $t('function.menu.search') }}</el-button>
        <!--          导出  -->
        <el-button size="mini" v-if="this.isAgent"  type="success" icon="el-icon-document" :loading="btnloading" @click="handleExport">{{ $t('corp.common.export') }}</el-button>
      </el-form>
      <el-table
          :key="tableKey"
          v-loading="listLoading"
          :data="list"
          border
          size="mini"
          fit
          highlight-current-row
          style="width: 100%;"
      >
        <!-- 操作 -->
        <el-table-column :label="$t('sysOperationLog.moduleName')" align="center" class-name="small-padding fixed-width">
          <template slot-scope="{row}">
            <!-- 查看 -->
            <el-button icon="el-icon-search" size="mini" :loading="btnloading" :title="$t('button.view')" circle @click="handleView(row)" />
            <!-- 订单发货 -->
            <el-button v-if="isAgent && row.sendFlag === '0' && row.status !== '0' " icon="el-icon-check" size="mini" :loading="btnloading" type="success" :title="$t('lm.send.order')" circle @click="handleSendGoods(row)" />
            <!-- 取消订单 -->
            <!--            代办处显示-->
            <el-button v-if="isAgent && row.locked === 0 && row.sendFlag === '0' && row.periodWeek === row.nowWeek" icon="el-icon-close" :loading="btnloading" type="danger" :title="$t('poorder.cancelorder')" size="mini" circle @click="handleUpdate(row)" />
            <!--            经销商显示-->
            <el-button v-if="!isAgent && row.orderType !== '17' && row.sendFlag === '0' && row.periodWeek === row.nowWeek" icon="el-icon-close" :loading="btnloading" type="danger" :title="$t('poorder.cancelorder')" size="mini" circle @click="handleUpdate(row)" />
          </template>
        </el-table-column>
        <!--      期次-->
        <el-table-column :label="$t('PoOrder.periodWeek')" prop="periodWeek" align="center" />
        <!--     订单编号 -->
        <el-table-column :label="$t('poOrder.orderNo')" prop="orderNo" align="center" />
        <!--     单据类型 -->
        <el-table-column :label="$t('fiAcInput.orderType')" prop="orderType" align="center" >
          <template v-slot="{row}">
            {{$lt(initDict.orderTyoe,row.orderType)}}
          </template>
        </el-table-column>
        <!--     单据状态 -->
        <el-table-column :label="$t('pdRetManifest.receiptStatus')" prop="status" align="center" >
          <template v-slot="{row}">
            {{$lt(initDict.status,row.status)}}
          </template>
        </el-table-column>
        <!--      经销商-->
        <el-table-column :label="$t('common.member')" prop="memberName" align="center" />
<!--        是否发货-->
        <el-table-column :label="$t('pdQmanifest.sendstatus')" align="center" >
          <template v-slot="{row}">
            <div v-if="row.sendFlag === '0'">{{$t('yesno.no')}}</div>
            <div v-else-if="row.sendFlag === '1'">{{$t('yesno.yes')}}</div>
          </template>
        </el-table-column>
        <!--      金额-->
        <el-table-column :label="$t('pmEfuboCard.amount')" prop="totalAmount" align="center" />
        <!--      换货积分-->
        <el-table-column :label="$t('FV')" prop="totalFv" align="center" />
        <!--      创建时间-->
        <el-table-column :label="$t('Common.createTime')" prop="createTime" align="center" />
      </el-table>
      <!-- 分页组件 -->
      <pagination
          v-show="total>0"
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          @pagination="getList"
      />
      <p style="font-weight: 600 ;color: green">{{this.$t('saFiIncomeReport.title.total') +'：'}}<span style="color:red;">{{this.totalAmountSum}}</span></p>
    </div>
  </div>
</template>

<script>
import {cancelOrders, orderList, orderListExcel} from "@/api/ay-business-manager/orderquery";
import {balanceSum} from "@/api/member";
import {mapGetters} from "vuex";
import Pagination from '@/components/Pagination'
import {orderSends} from "@/api/ay-business-manager/firstpurchaseorder";

export default {
  name: "OrderQuery",
  components: { Pagination },
  data(){
    return{
      btnloading: false,
      listLoading: false,
      BatchImportString: 0,
      listQuery: { // 查询条件
        page: 1,
        limit: 20,
        companyCode: null
      },
      tableKey: 0,
      list: [],
      total: 0,
      canUseF$:0,
      totalAmountSum:0,
      wWeekList:null,
      companyCodelist: null,
      dcNoBuledialong:true,
      activeName:'first',
      initDict:{
        orderTyoe:'po.allordertype.cn',
        bdPeriodStatus:'pdmanifestsettle.receiptstatus',
        status:'bdrulenet.status',
        isGift: 'po.order.isgive',
        yesno: 'yesno'
      }
    }
  },
  computed: {
    ...mapGetters([
      'isAgent'
    ]),
    orderTyleList(){
      return this.$ll(this.initDict.orderTyoe)
    },
    bdPeriodStatusList(){
      return  this.$ll(this.initDict.bdPeriodStatus)
    }
  },
  created() {
    // this.getList()
  },
  mounted() {
    this.wWeekList = JSON.parse(sessionStorage.getItem('wWeekLocalList'))
  },
  methods:{
    //  搜索
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    getList() {
      this.btnloading = true
      this.listLoading = true
      this.totalAmountSum = 0
      orderList({ ...this.listQuery }).then(res => {
        if(res.data.records.length > 0){
          this.totalAmountSum = res.data.records[0].totalAmountSum
        }else{
          this.totalAmountSum = 0
        }
        this.list = res.data.records
        this.total = +res.data.total
        this.btnloading = false
        this.listLoading = false
      }).catch(err => {
        console.error(err)
        this.btnloading = false
        this.listLoading = false
      })
      balanceSum({...this.listQuery}).then(res=>{
        this.canUseF$ = res.data.canUseF$Local
      }).catch(err=>{
        console.error(err)
      })
    },
    handleView(row) {
      this.btnLoading = true
      this.$router.push({name: 'ViewOrderquery', params: {id: row.id}})
    },
    // 订单发货
    handleSendGoods(row) {
      this.$confirm(this.$t('fi.sure.handle'), this.$t('common.tips'), {
        confirmButtonText: this.$t('button.confirm'),
        cancelButtonText: this.$t('operation.button.cancel'),
        type: 'warning'
      }).then(() => {
        this.btnloading = true
        orderSends({ 'id': row.id }).then(() => {
          this.btnloading = false
          this.getList()
          this.$message.success(this.$t('lm.send.order') + this.$t('Common.success'))
        }).catch(err => {
          this.btnloading = false
          console.error(err)
          this.$message.error(this.$t('bdSendRegister.operaterFail'))
        })
      }).catch(() => {
        this.$message.info(this.$t('operation.button.cancel'))
        this.btnloading = false
      })
    },
    handleUpdate(row){
      let ids = []
      ids.push(row.id)
      this.$confirm(this.$t('fi.sure.handle'), this.$t('common.tips'), {
        confirmButtonText: this.$t('button.confirm'),
        cancelButtonText: this.$t('operation.button.cancel'),
        type: 'warning'
      }).then(() => {
        this.btnloading = true
        cancelOrders( ids ).then(() => {
          this.btnloading = false
          this.getList()
          this.$message.success(this.$t('bdSendRegister.operaterSuccess'))
        }).catch(err => {
          this.btnloading = false
          console.error(err)
          this.$message.error(this.$t('bdSendRegister.operaterFail'))
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('operation.button.cancel')
        })
        this.btnloading = false
      })
    },
    othergoods(row){
      this.$router.push({name:'OrderQueryOthers',params:{id:row.id}})
    },
    // 导出
    handleExport() {
      this.btnloading = true
      orderListExcel({ ...this.listQuery }).then(response => {
        const lists = response.data
        for (let i = 0; i < lists.length; i++) {
          // lists[i].orderType = this.$lt('po.allordertype.cn', lists[i].orderType)
          lists[i].orderType = this.$lt(this.initDict.orderTyoe, lists[i].orderType)
          lists[i].isGive = this.$lt(this.initDict.isGift, lists[i].isGive)
          lists[i].status = this.$lt(this.initDict.status, lists[i].status)
          lists[i].sendFlag = this.$lt(this.initDict.yesno,lists[i].sendFlag)
        }
        const tHeader = [
          //   期次
          this.$t('PoOrder.periodWeek'),
          //   订单编号
          this.$t('poOrder.orderNo'),
          //   会员编号
          this.$t('poOrder.memberNo'),
          //   会员姓名
          this.$t('person.name'),
          //   商品编号
          this.$t('pmProductList.productId'),
          //   商品名称
          this.$t('BiGoods.name'),
          //   订购数量
          this.$t('poOrder.count'),
          //   单据类型
          this.$t('fiAcInput.orderType'),
          //   单据状态
          this.$t('pdRetManifest.receiptStatus'),
          //   是否发货
          this.$t('pdQmanifest.sendstatus'),
          //   是否赠品
          this.$t('bigoods.send.ornot')
        ]	// 表头
        const filterVal = [
          'periodWeek','orderNo','memberNo','name','goodscode','yindu','quantity','orderType','status','sendFlag','isGive'
        ]	 // 对应json数据中的key，顺序与表头顺序一致
        // 远程请求要导出的数据
        const data = this.formatJson(filterVal, lists)
        import('@/vendor/Export2Excel').then(excel => {
          excel.export_json_to_excel({
            header: tHeader,	// 表头，必填
            data,	// 具体数据，必填
            filename: 'excel',	// 导出文件名称，非必填
            autoWidth: true,	// 非必填
            bookType: 'xlsx'	// 非必填
          })
          this.btnloading = false
        })
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        return v[j]
      }))
    }
  }
}
</script>

<style scoped>

</style>
